import { apiToDisplaySession } from '@/types/session'
import type { APISession } from '@/types/session'

interface SessionDisplayProps {
  session: APISession;
  className?: string;
}

export const SessionDisplay = ({ session, className }: SessionDisplayProps) => {
  return (
    <span className={className}>
      {apiToDisplaySession(session)}
    </span>
  )
}